/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface PatchNoteEntry {
  title: string;
  body: string;
}

export interface PatchNoteCategory {
  name: string;
  entries: PatchNoteEntry[];
}

export interface PatchNoteVersion {
  version: string;
  date: string;
  tag: string;
  categories: PatchNoteCategory[];
}

export interface PatchNoteIndexEntry {
  version: string;
  date: string;
  tag: string;
}

@Injectable({ providedIn: 'root' })
export class PatchNotesService {
  private readonly basePath = 'assets/patch-notes';

  constructor(private http: HttpClient) {}

  getIndex(): Observable<PatchNoteIndexEntry[]> {
    return this.http.get<PatchNoteIndexEntry[]>(`${this.basePath}/index.json`);
  }

  getVersion(version: string): Observable<PatchNoteVersion> {
    return this.http.get<PatchNoteVersion>(`${this.basePath}/${version}.json`);
  }
}
